import { render, staticRenderFns } from "./developer-app-credentials-edit-dialog.vue?vue&type=template&id=20d703f7&scoped=true&"
import script from "./developer-app-credentials-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./developer-app-credentials-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d703f7",
  null
  
)

export default component.exports